export default function getValidationErrors(err) {
  const validationErrors = {};

  // Zod validation errors are structured differently than Yup
  if (err.errors) {
    err.errors.forEach((error) => {
      // For nested objects, join the path with dots
      const fieldName = error.path.join(".");
      validationErrors[fieldName] = error.message;
    });
  }

  return validationErrors;
}
